import "./MainScreen.scss";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export async function loader() {
  console.log("loader");
  return {};
}

export default function MainScreen() {
  const user = useSelector((state) => state.auth);
  console.log(user);

  return (
    <div className="main-screen">
      <header className="main-header">
        <div className="user-info">
          <h1>username: {user.username}</h1>
          <h1>role: {user.role}</h1>
        </div>
      </header>

      <Outlet />
    </div>
  );
}
